<template>
  <RolePermissionForm :isCreate="false"></RolePermissionForm>
</template>
<script>
import RolePermissionForm from "@/views/components/role-permission/RolePermissionForm.vue";

export default {
  name: "RolePermissionDetails",
  components: {
    RolePermissionForm,
  },
  data: () => ({}),
  mounted() {},
  computed: {},
  watch: {},
  methods: {},
};
</script>

<style></style>
